<script>
  import _ from 'lodash'
  import moment from 'moment'
  import { scrollTop } from '@/utils/assist'
  import PermissionUtils from '@/utils/permission'
  import RecordService from '@/request/record/record'
  import RecordConsultationService from '@/request/record/consultation'
  import RecordCourseService from '@/request/record/recordCourse'
  import RecordCommentService from '@/request/record/recordComment'
  import RecordAttentionService from '@/request/record/attentionRecord'
  import OrgService from '@/request/user/org'
  import PatientService from '@/request/patient/patient'
  import PatientAttentionService from '@/request/patient/attention'
  import OperationService from '@/request/aims/operation'
  import DiagnoseService from '@/request/record/diagnose'
  export default {
    name: "RecordDetail",
    data() {
      return {
        from: null,
        id: _.toInteger(this.$route.params.id),
        record: {},
        recordLoaded: false,
        hospital: {},
        pat: null,
        patient: {},
        safety: true,
        hasConsultation: false,
        operations: [],
        courses: [],
        hasComments: false,
        catalogs: [],
        visibleEditPatient: false,
        editPatient: {},
        visibleEditRecord: false,
        editRecord: {},
        visibleEditOperation: false,
        editOperation: {},
        visibleEditFollowup: false,
        visibleEditCourse: false,
        editCourse: {},
        visibleEditConsultation: false,
        editConsultation: {},
        attention: false,
        attentionRecord: false,
        visibleEditTransfer: false,
        PatientContactQrcode: {
          qrcode: null,
          loadding: false,
          err: null
        },
        visibleQrcode: false,
        visibleMoreRecord: false,
        now: moment().valueOf(),
        enableAbsolute: false,
        left: 0,
        right: 0,
        diagnoses: [], // 智能等级列表
        visibleEditTag: false,
        recordTags: []
      }
    },
    created() {
      this.loadRecord()
      this.listOperation()
      this.listCourse()
      this.checkConsultation()
      this.checkComment()
    },
    mounted() {
      const that = this;
      const el = that.$refs.recordInfoScrollbar.wrap
      this.handleScroll()
      el.addEventListener('scroll', that.handleScroll);
      window.addEventListener('resize', that.handleScroll);
    },
    beforeDestroy () {
      const that = this;
      const el = that.$refs.recordInfoScrollbar.wrap
      el.removeEventListener('scroll', that.handleScroll);
      window.removeEventListener('resize', that.handleScroll);
    },
    watch: {
      '$route.params.id': function (val) {
        if (!val) {
          this.$message.error('病历不存在或已被删除')
          this.$router.go(-1)
        }
        this.id = _.toInteger(this.$route.params.id)
      },
      'record.sn' : function (val) {
        if (val) {
          this.listDiagnose()
        }
      },
      id(newVal, oldVal) {
        if (newVal === oldVal) {
          return
        }
        this.recordLoaded = false
        this.record = {}
        this.loadRecord()
        this.listOperation()
        this.listCourse()
        this.checkConsultation()
        this.checkComment()
      },
      recordLoaded(newVal, oldVal) {
        if (!oldVal && newVal) {
          this.pat = _.toInteger(this.record.pat)
          this.loadHospital()
          this.loadPatient()
          this.isAttentionRecord()
        }
      },
      pat(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.loadPatient()
          this.isAttention()
        } else if (!newVal) {
          this.patient = {}
          this.attention = false
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.from = from.name || null
      })
    },
    methods: {
      handleScroll () {
        const that = this
        this.$nextTick(() => {
          const el = that.$refs.recordInfoScrollbar.wrap
          const recordContentWidth = that.$refs.recordContent.clientWidth
          if (el.scrollWidth > 1200) {
            that.left = el.scrollWidth / 2 - recordContentWidth / 2 - 160 - el.scrollLeft + 'px';
            that.right = el.scrollWidth / 2 - recordContentWidth / 2 - 160 + (el.clientWidth - el.scrollWidth + el.scrollLeft) + 'px'
          } else {
            that.left = 0
          }
        })
      },
      hasPermission(sns) {
        return PermissionUtils.hasPermission(sns, this.$store.getters.permissions, false)
      },
      backPage() {
        if (!this.from || this.from === 'record_add' || this.from === 'record_show' || this.from === 'record_list') {
          this.$router.push({name: 'record_list'})
        } else if (this.from) {
          this.$router.go(-1)
          // this.$router.push({name: this.from})
        }/* else {
          this.$router.go(-1)
        }*/
      },
      insertCatalog (number, id, name) {
        if (_.findIndex(this.catalogs, {'id': id}) >= 0) {
          return
        }
        this.catalogs.push({
          number: number,
          id: id,
          name: name
        })
        this.catalogs = _.sortBy(this.catalogs, ['number'])
      },
      removeCatalog (id) {
        if (!id) {
          return
        }
        _.remove(this.catalogs, catalog => {
          return catalog.id === id
        })
      },
      loadRecord() {
        let self = this
        RecordService.load({
          id: self.id
        }).then(data => {
          if (data.result) {
            self.record = _.cloneDeep(data.result)
            if (self.record.tag) {
              const tags = _.join(self.record.tag.substring(1, self.record.tag.length - 1).split(')('));
              this.recordTags = tags.split(',')
            } else {
              this.recordTags = []
            }
            self.insertCatalog(20, 'record_show_record', '病历信息')
            self.insertCatalog(40, 'record_show_images', '图片信息')
            if (self.record.hasFollowup) {
              self.insertCatalog(70, 'record_show_followup', '随访计划')
            }
            self.recordLoaded = true
          } else {
            self.$message.error('病历不存在或已被删除')
            self.backPage()
          }
        }, err => {
          if (err) {
            self.$message.error(err)
          } else {
            self.$message.error('病历不存在或已被删除')
          }
          self.backPage()
        })
      },
      loadHospital () {
        if (!this.record || !this.record.oid) {
          return
        }
        let self = this
        OrgService.loadOrg({
          descendantId: self.record.oid,
          parentTypeSn: 'lx0001001'
        }).then(data => {
          if (data.result) {
            self.hospital = _.cloneDeep(data.result)
          }
        })
      },
      loadPatient() {
        if (!this.record || !this.record.pat) {
          return
        }
        let self = this
        PatientService.load({
          id: self.record.pat
        }).then(data => {
          if (data.result) {
            self.patient = _.cloneDeep(data.result)
            self.pat = self.patient['id']
            self.insertCatalog(10, 'record_show_patient', '患者信息')
          }
        })
      },
      /*handlerRecordTool(name, record) {
        if (_.isEmpty(record) || record.id != this.id) {
          return
        }
        switch (name) {
          case 'hospitalized':
            this.handleHospitalized()
            break
          case 'operation':
            this.handleEditOperation()
            break
          case 'followup':
            this.handleEditFollowup()
            break
          case 'course':
            this.handleEditCourse()
            break
          case 'comment':
            this.startAddComment()
            break
          case 'consultation':
            this.handleConsultation()
            break
          case 'leave':
            this.handleLeave()
            break
          case 'inhospital':
            this.changeState(1)
            break
          case 'transfer':
            this.transferOrg()
            break
          case 'changeBedid':
            this.changeBedid()
            break
          case 'share':
            this.handleShare()
            break
          case 'qrcode':
            this.showQrcode()
            break
          case 'delete':
            this.handleDeleteRecord()
            break
          default:
            return
        }
      },*/
      /*patientMoreRecord(patient) {
        if (!patient) {
          return
        }
        if (this.pat != patient) {
          this.pat = patient
        }
        this. = true
      },*/
      /*changePatientRecord(record) {
        if (!record) {
          return
        }
        this.$router.push({name: 'record_show', params: {id: record}})
      },*/
      toRecord (record) {
        if (!record) {
          return
        }
        if (record === this.record.id) {
          return
        }
        this.$router.push({name: 'record_show', params: {id: record}})
      },
      listDiagnose () {
        let self = this
        // DiagnoseService.list({rsn: self.record.sn}).then(res => {
        DiagnoseService.list({rsn: self.record.sn}).then(res => {
          self.diagnoses = res.result || []
          if (self.diagnoses.length > 0) {
            self.insertCatalog(90, 'record_show_diagnose', '智能分级')
          }
        })
      },
      listOperation () {
        let self = this
        OperationService.list({
          recordId: self.id
        }).then(operations => {
          self.operations = operations ? _.sortBy(operations.result, [function (o) { return -o.arrangedStartTime }]) : []
          if (!_.isEmpty(self.operations)) {
            self.insertCatalog(30, 'record_show_operation', '手术信息')
          }
          /*if (self.operations.length === 1) {
              self.insertCatalog(30, 'record_show_operation_' + self.operations[0].id, '手术信息')
          } else {
              _.forEach(self.operations, (value, index) => {
                  self.insertCatalog(30, 'record_show_operation_' + value.id, '手术信息(' + (index + 1) + ')')
              })
          }*/
        })
      },
      listCourse () {
        let self = this
        RecordCourseService.list({
          rid: self.id
        }).then(courses => {
          courses = courses.result ? _.sortBy(courses.result, ['time']) : []
          self.courses = _.cloneDeep(courses)
          if (!_.isEmpty(self.courses)) {
            self.insertCatalog(50, 'record_show_course', '病程')
          }
          /*_.forEach(self.courses, (value, i) => {
              // self.insertCatalog(50, 'record_show_course_' + value.id, '病程(' + value.tag + ')')
              self.insertCatalog(50, 'record_show_course_' + value.id, '病程(' + (i + 1) + ')')
          })*/
        })
      },
      isAttention () {
        if (!this.pat) {
          this.attention = false
          return
        }
        PatientAttentionService.load({
          pat: this.pat
        }).then(res => {
          this.attention = !_.isEmpty(res.result);
        }).catch(() => {
          this.attention = false
        })
      },
      isAttentionRecord () {
        RecordAttentionService.list({
          rids: this.id
        }).then(res => {
          this.attentionRecord = !_.isEmpty(res.result);
        })
      },
      checkConsultation () {
        RecordConsultationService.list({
          recordId: this.id
        }).then(data => {
          if (!_.isEmpty(data.result)) {
            this.hasConsultation = true
            this.insertCatalog(60, 'record_show_consultation', '会诊记录')
          }
        })
      },
      checkComment (refresh) {
        let self = this
        RecordCommentService.listComment({
          recordId: self.id
        }).then(data => {
          if (!_.isEmpty(data.result)) {
            self.hasComments = true
            self.insertCatalog(80, 'record_show_comment', '批注')
            if (refresh && self.$refs['recordCommentsList']) {
              self.$refs['recordCommentsList'].listComment()
            }
          } else {
            self.hasComments = false
            self.removeCatalog('record_show_comment')
          }
        })
      },
      /* handleAddFollowupRecord (item) {
        console.log(item)
      }, */
      scrollTo (name) {
        if (!this.$refs.recordInfoScrollbar || !this.$refs.recordInfoScrollbar.wrap) {
          return
        }
        let from = this.$refs.recordInfoScrollbar.wrap.scrollTop
        let to = 0
        let target = name ? this.$refs[name] : null
        if (_.isArray(target)) {
          target = target[0]
        }
        if (!target) {
          to = 0
        } else {
          to = target.offsetTop
        }
        scrollTop(this.$refs.recordInfoScrollbar.wrap, from, to, 1000)
      },
      handleCloseEditPatient () {
        this.visibleEditPatient = false
        this.editPatient = {}
      },
      editPatientSuccess (patient) {
        if (_.isEqual(patient, this.patient)) {
          this.visibleEditPatient = false
          return
        }
        if (this.patient.id !== patient.id) {
          let _record = _.cloneDeep(this.record)
          _record.pat = patient.id
          RecordService.save(_record).then(res => {
            this.record = _.cloneDeep(res.result)
          }).catch(error => {
            this.$message.error(error)
          })
        }
        _.assign(this.patient, patient)
        this.visibleEditPatient = false
      },
      handleEditPatient () {
        this.editPatient = _.cloneDeep(this.patient)
        this.visibleEditPatient = true
      },
      handleCloseEditRecord () {
        this.visibleEditRecord = false
        this.editRecord = {}
      },
      handleEditRecord () {
        this.editRecord = _.cloneDeep(this.record)
        this.visibleEditRecord = true
      },
      editRecordSuccess (record) {
        if (_.isEqual(record, this.record)) {
          return
        }
        _.assign(this.record, record)
      },
      handleLeave () {
        let self = this
        let item = _.cloneDeep(self.record)
        self.$confirm('患者：' + item.patName + '、床号：' + item.bedid + '，确认将此病历修改为出院状态？', '提示', {type: 'warning'}).then(() => {
          item.state = 7
          RecordService.save(item).then(res => {
            self.record = _.cloneDeep(res.result)
          }, error => {
            self.$message.error(error)
          })
        }, () => {
          self.$message({
            message: '取消操作!',
            type: 'success'
          })
        })
      },
      handleHospitalized () {
        let self = this
        self.$prompt('请输入床位号', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          self.checkBedid(value).then(() => {
            let item = {
              pat: self.record.pat,
              historySn: self.record.historySn,
              hospitalized: 1,
              bedid: value,
              oid: self.record.oid,
              attending: self.record.attending,
              diagnose: self.record.diagnose,
              symptom: self.record.symptom,
              stateOfAnIllness: self.record.stateOfAnIllness,
              preliminaryAnalysis: self.record.preliminaryAnalysis,
              subjectIds: self.record.subjectIds,
              position: self.record.position,
              tag: self.record.tag,
              pathId: self.record.pathId,
              remark: self.record.remark,
              discoverDate: self.record.discoverDate,
              visitsDate: self.record.visitsDate,
              admissionDate: self.record.admissionDate
            }
            RecordService.save(item).then(res => {
              item = _.cloneDeep(res.result || {})
              if (!_.isEmpty(item)) {
                self.from = 'record_show'
                self.id = item.id
                self.$router.push({name: 'record_show', params: {id: item.id}})
              }
            }, error => {
              self.$message.error(error || '转入院失败')
            })
          }).catch(() => {
            self.handleHospitalized()
          })
        })
      },
      changeState: function (state) {
        let self = this
        if (!state) {
          return
        }
        if (self.record.state === state) {
          return
        }
        if (!self.record.hospitalized) {
          return
        }
        let options = {}
        let remark = '确认修改病历状态?'
        if (self.record.state === 7 && state === 1) {
          remark = '确定将患者' + self.record.patName + '转入院?[如果需要改床位号请在下面输入]'
          options.showInput = true
          options.inputValue = self.record.bedid
          options.confirmButtonText = '确定'
          options.cancelButtonText = '取消'
        }
        self.$confirm(remark, '提示', options).then(({ value }) => {
          let item = _.cloneDeep(self.record)
          item.state = state
          if (value) {
            self.checkBedid(value).then(() => {
              item.bedid = value
              RecordService.save(item).then(res => {
                self.record = res.result || {}
              }, error => {
                self.$message.error(error || '更改状态失败')
              })
            }).catch(() => {
              self.changeState(state)
            })
          } else {
            RecordService.save(item).then(res => {
              self.record = res.result || {}
            }, error => {
              self.$message.error(error || '更改状态失败')
            })
          }
        })
      },
      changeBedid () {
        let self = this
        if (!self.record.hospitalized) {
          return
        }
        self.$confirm('请在下面输入新床位号', '正在转床', {
          showInput: true,
          inputValue: self.record.bedid,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({value}) => {
          let item = _.cloneDeep(self.record)
          if (value === self.record.bedid) {
            return
          }
          if (value) {
            self.checkBedid(value).then(() => {
              item.bedid = value
              RecordService.save(item).then(res => {
                self.record = res.result || {}
              }, error => {
                self.$message.error(error || '转床失败')
              })
            }).catch(() => {
              self.changeBedid()
            })
          } else {
            item.bedid = null
            RecordService.save(item).then(res => {
              self.record = res.result || {}
            }, error => {
              self.$message.error(error || '转床失败')
            })
          }
        })
      },
      checkBedid (bedid) {
        let self = this
        return new Promise((resolve, reject) => {
          RecordService.count({
            hospitalized: 1,
            status: '1,2,3,4,5',
            hids: self.hospital.id,
            bedid: bedid
          }).then(res => {
            let count = res.result
            if (!count) {
              resolve(bedid)
              return
            }
            self.$confirm('床位号：' + bedid + '已经被其它患者占用！如果继续保存，原病历将自动出院！', '提示', {
              confirmButtonText: '强制出院',
              cancelButtonText: '更改床号',
              type: 'warning'
            }).then(() => {
              this.$message({
                message: '保存后，原[' + bedid + ']床的病历出院',
                type: 'warning'
              })
              resolve(bedid)
            }).catch(() => {
              reject(new Error('检验失败'))
            })
          })
        })
      },
      changeRecordTag (tags) {
        this.recordTags = tags
      },
      handleClose (tag) {
        this.recordTags.splice(this.recordTags.indexOf(tag), 1);
        this.saveRecordTags()
      },
      saveRecordTags () {
        const _record = _.clone(this.record)
        if (this.recordTags.toString() !== _record.tag) {
          if (this.recordTags.length === 0) {
            _record.tag = null
          } else {
            const recordTag = _.join(this.recordTags, ')(')
            _record.tag = '(' + recordTag + ')'
          }
          RecordService.save(_record).then(res => {
            this.record = _.cloneDeep(res.result)
          })
        }
      },
      handleDeleteRecord () {
        if (!this.id) {
          this.$message.error('病历信息有误，请刷新页面重试删除')
          return
        }
        let self = this
        self.$confirm('确认删除病历吗?', '提示', {type: 'warning'}).then(() => {
          RecordService.delete({
            id: self.id
          }).then(() => {
            self.backPage()
          }, err => {
            self.$message.error(err)
          }).catch(error => {
            self.$message.error(error || '删除病历失败')
          })
        }, () => {
          self.$message({
            message: '取消操作!',
            type: 'info'
          })
        })
      },
      handleEditCourse (item) {
        this.editCourse = item ? _.cloneDeep(item) : { drid: this.id, id: null }
        this.visibleEditCourse = true
      },
      handleDeleteCourse (course) {
        if (!course) {
          return
        }
        this.$confirm('确认删除病程[' + course.tag + ']吗?', '提示', {type: 'warning'}).then(() => {
          RecordCourseService.delete({
            id: course.id
          }).then(() => {
            this.listCourse()
          }).catch(error => {
            this.$message.error(error || '删除病程失败')
          })
        }, () => {
          this.$message({
            message: '取消操作!',
            type: 'info'
          })
        })
      },
      handleSaveCourseDone (course) {
        if (!_.isEmpty(course)) {
          this.listCourse()
          if (!_.isEmpty(this.$refs['images_course_' + course.id])) {
            _.forEach(this.$refs['images_course_' + course.id], item => {
              item.listImage()
            })
          }
        }
        this.visibleEditCourse = false
      },
      handleCancleEditCourse () {
        if (this.editCourse.id) {
          if (!_.isEmpty(this.$refs['images_course_' + this.editCourse.id])) {
            _.forEach(this.$refs['images_course_' + this.editCourse.id], item => {
              item.listImage()
            })
          }
        }
        this.editCourse = {}
      },
      startAddComment () {
        let self = this
        self.$prompt('', '批注', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '请输入批注内容',
          inputType: 'textarea',
          inputPattern: /\S+/,
          inputErrorMessage: '内容不能为空'
        }).then(({ value }) => {
          RecordCommentService.saveComment({
            recordId: self.id,
            content: value
          }).then(() => {
            self.checkComment(true)
          }, error => {
            self.$message.error(error || '批注失败')
          })
        }).catch(() => {
          self.$message({
            message: '取消操作',
            type: 'info'
          })
        })
      },
      handleDeleteComment () {
        this.checkComment()
      },
      handleShare () {
        this.$router.push({name: 'databank_normcaseadd', params: {id: 0, rid: this.id}})
      },
      // 关注患者
      handleAttention (type) {
        if (!this.pat) {
          return
        }
        if (!type) {
          type = 'add'
        }
        let fn = type === 'add' ? PatientAttentionService.save : PatientAttentionService.delete
        fn({
          pat: this.pat
        }).then(res => {
          if (!_.isEmpty(res.result) && type === 'add') {
            this.attention = true
            this.$message({
              message: '成功关注患者',
              type: 'success'
            })
          } else {
            this.attention = false
            this.$message({
              message: '取消关注患者',
              type: 'success'
            })
          }
        })
      },
      // 关注病历
      handleAttentionRecord (type) {
        if (!type) {
          type = 'add'
        }
        let fn = type === 'add' ? RecordAttentionService.save : RecordAttentionService.delete
        fn({
          rid: this.id
        }).then(res => {
          if (!_.isEmpty(res.result) && type === 'add') {
            this.attentionRecord = true
            this.$message({
              message: '成功关注了病历',
              type: 'success'
            })
          } else {
            this.attentionRecord = false
            this.$message({
              message: '取消关注病历',
              type: 'success'
            })
          }
        })
      },
      handleApproveOperation (operation) {
        if (!operation) {
          return
        }
        this.$confirm('是否同意患者[' + operation.patName + ']的手术申请？', '审批', {
          distinguishCancelAndClose: true,
          confirmButtonText: '同意',
          cancelButtonText: '拒绝'
        }).then(() => {
          OperationService.approve({
            id: operation.id,
            result: 1,
            mess: null
          }).then(() => {
            this.listOperation()
          })
        }).catch(action => {
          if (action !== 'cancel') {
            return
          }
          this.$prompt('请输入拒绝理由', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /\S+/,
            inputErrorMessage: '拒绝理由不能为空',
            inputPlaceholder: '请输入拒绝理由'
          }).then(({ value }) => {
            OperationService.approve({
              id: operation.id,
              result: 0,
              mess: value
            }).then(() => {
              this.listOperation()
            })
          }).catch(() => {
            this.approveOperation(operation)
          })
        })
      },
      handleFinishOperation (operation) {
        if (operation.currentState === 5) {
          this.$alert('已经完成的手术', '提示', {
            confirmButtonText: '确定'
          })
          return
        }
        this.$confirm('请确认 ' + operation.patName + ' 的手术已经完成(确认后不可撤销)', '完成手术', {type: 'warning'}).then(() => {
          operation.currentState = 5
          OperationService.save(operation).then(() => {
            this.listOperation()
          }).catch(error => {
            this.$message.error(error || '操作出错')
          })
        }).catch(() => {
          this.$message({
            message: '取消操作!',
            type: 'success'
          })
        })
      },
      handleDeleteOperation (operation) {
        if (!operation || !operation.id) {
          this.$message({
            message: '数据出错了，请刷新后重试',
            type: 'info'
          })
          return
        }
        if (this.$store.getters.user.id !== operation.applyDoc) {
          this.$alert('只允许删除自己申请的手术', '提示', {
            confirmButtonText: '确定'
          })
          return
        }
        if (this.hasPermission('per_opration_001002')) {
          if (operation.currentState > 3 && operation.currentState <= 5) {
            this.$alert('这台手术当前状态不允许删除', '提示', {
              confirmButtonText: '确定'
            })
            return
          }
        } else {
          if (operation.currentState > 2 && operation.currentState <= 5) {
            this.$alert('这台手术当前状态不允许删除', '提示', {
              confirmButtonText: '确定'
            })
            return
          }
        }
        this.$confirm('确认删除这台手术吗?', '提示', {type: 'warning'}).then(() => {
          OperationService.delete({
            id: operation.id
          }).then(() => {
            this.listOperation()
          })
        }).catch(() => {
          this.$message({
            message: '取消删除!',
            type: 'success'
          })
        })
      },
      handleEditOperation (operation) {
        this.editOperation = operation ? _.cloneDeep(operation) : {
          drid: this.id
        }
        this.visibleEditOperation = true
      },
      handleCloseEditOperation () {
        this.visibleEditOperation = false
        this.editOperation = {}
      },
      editOperationSuccess () {
        this.listOperation()
        this.visibleEditOperation = false
      },
      /*handleConsultation () {
        if (this.$refs['consultationListComments']) {
          this.$refs['consultationListComments'].startEditConsultation()
          return
        }
        this.editConsultation = {
          recordId: this.id
        }
        this.visibleEditConsultation = true
      },*/
      handleEditFollowup () {
        this.visibleEditFollowup = true
      },
      handleSaveFollowupDone () {
        if (this.$refs['followupListComments']) {
          this.$refs['followupListComments'].listFollowup()
        }
        if (!this.record.hasFollowup) {
          this.$set(this.record, 'hasFollowup', 1)
          this.insertCatalog(70, 'record_show_followup', '随访计划')
        }
        this.visibleEditFollowup = false
      },
      handleCancelEditConsultation () {
        this.editConsultation = {}
      },
      handleSaveConsultationDone () {
        this.visibleEditConsultation = false
        this.checkConsultation()
      },
      transferOrg () {
        this.visibleEditTransfer = true
      },
      handleSaveTransferDone (res) {
        this.visibleEditTransfer = false
        if (_.isEmpty(res)) {
          return
        }
        if (res.trecord === res.frecord) {
          this.loadRecord()
        } else {
          this.$router.push({name: 'record_show', params: {id: res.trecord}})
        }
      },
      /*showQrcode () {
        if (!this.record.id) {
          this.$message.error('生成二维码失败')
        }
        this.PatientContactQrcode.loadding = true
        this.PatientContactQrcode.err = null
        this.visibleQrcode = true
        PatientContactService.save({
          rid: this.record.id
        }).then(res => {
          let pc = res.result
          if (_.isEmpty(pc) || !pc.qrcode) {
            this.PatientContactQrcode.err = '生成二维码失败'
          } else {
            this.PatientContactQrcode.qrcode = pc.qrcode
          }
        }).catch(error => {
          this.PatientContactQrcode.err = error ? error.message : '生成二维码失败'
        }).finally(() => {
          this.PatientContactQrcode.loadding = false
        })
      },
      closeQrcode () {
        this.PatientContactQrcode.qrcode = null
        this.PatientContactQrcode.loadding = false
        this.PatientContactQrcode.err = null
      },*/
      handlePatientCommand (command) {
        if (!command) {
          return
        }
        switch (command) {
          case 'edit':
            this.handleEditPatient()
            break
          case 'attention':
            this.handleAttention(this.attention ? 'delete' : 'add')
            break
        }
      },
      handleSelectedPatientRecord (rid) {
        this.visibleMoreRecord = false
        if (!rid) {
          return
        }
        this.$router.push({name: 'record_show', params: {id: rid}})
      },
    },
    filters: {
      operationStatus(value) {
        let result = '未知'
        switch (value) {
          case 2:
            result = '待审批'
            break
          case 3:
            result = '待排班'
            break
          case 4:
            result = '已排班'
            break
          case 5:
            result = '已完成'
            break
          case 6:
            result = '审批不通过'
            break
          case 7:
            result = '手术室退回'
            break
        }
        return result
      },
      formatDateTimeDynamic(value) {
        if (!value) {
          return '未知时间'
        }
        if (Object.prototype.toString.call(value) === '[object String]') {
          return value
        }
        if (value === '' || isNaN(value)) {
          return '未知时间'
        }
        if (value <= 0) {
          return '未知时间'
        }
        if (value < 10000000000) {
          value *= 1000
        }
        let time = new Date(value)
        let tY = time.getFullYear()
        let tM = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1
        let tD = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
        let th = time.getHours() < 10 ? '0' + time.getHours() : time.getHours()
        let tm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()
        let ts = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds()
        let now = new Date()
        let nY = now.getFullYear()
        let nM = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1
        let nD = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
        let result = ''
        if (tY !== nY) {
          result += tY + '年'
        }
        if (tM !== nM || tD !== nD) {
          result += tM + '月'
          result += tD + '日'
        }
        if (result === '') {
          result = th + ':' + tm + ':' + ts
        }
        return result
      },
      formatDuration(value) {
        if (value === '无') {
          return '无'
        }
        return (Math.round(value * 10 / 1000 / 60 / 60) / 10) + '小时'
      }
    }
  }
</script>

<template>
  <el-container>
    <el-header height="45px">
      <el-form :inline="true" class="demo-form-inline" size="small">
        <el-form-item>
          <el-button @click="backPage()">返 回</el-button>
        </el-form-item>
        <el-form-item v-if="record.id && record.hospitalized !== 1">
          <el-button type="primary" @click="handleHospitalized()">转为住院</el-button>
        </el-form-item>
        <el-form-item v-if="record.id && record.hospitalized === 1">
          <el-button type="primary" @click="handleEditOperation()">申请手术</el-button>
        </el-form-item>
        <el-form-item v-if="record.id">
          <el-button type="primary" @click="handleEditFollowup()">添加随访</el-button>
        </el-form-item>
        <el-form-item v-if="record.id">
          <el-button type="primary" @click="handleEditCourse()">添加病程</el-button>
        </el-form-item>
        <el-form-item v-if="record.id && hasPermission('per_comment_001001')">
          <el-button type="primary" @click="startAddComment()">添加批注</el-button>
        </el-form-item>
        <!--<el-form-item v-if="record.id">
          <el-button type="primary" @click="handleConsultation()">发起会诊</el-button>
        </el-form-item>-->
        <el-form-item v-if="record.id && record.hospitalized === 1 && record.state !== 7">
          <el-button type="primary" @click="handleLeave()">出院</el-button>
        </el-form-item>
        <el-form-item v-if="record && record.state === 7">
          <el-button type="primary" @click="changeState(1)">返回在院</el-button>
        </el-form-item>
        <el-form-item v-if="record.id && record.hospitalized === 1">
          <el-button type="primary" @click="transferOrg()">转科</el-button>
        </el-form-item>
        <el-form-item v-if="record.id && record.hospitalized === 1">
          <el-button type="primary" @click="changeBedid()">转床</el-button>
        </el-form-item>
        <el-form-item v-if="record.id && !attention">
          <el-button type="primary" @click="handleAttention('add')">关注患者</el-button>
        </el-form-item>
        <el-form-item v-if="record.id && attention">
          <el-button type="primary" @click="handleAttention('delete')">取消关注</el-button>
        </el-form-item>
        <el-form-item v-if="record.id && !record.isNormCase">
          <el-button type="primary" @click="handleShare()">宣传病例</el-button>
        </el-form-item>
        <!--<el-form-item v-if="record.id">
          <el-button type="primary" @click="showQrcode()">二维码</el-button>
        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" @click="visibleEditTag = true">添加标签</el-button>
        </el-form-item>
        <el-form-item v-if="record.id
                    && now - record.createTime < 24 * 60 * 60 * 1000
                    && $store.getters.user && record.createId === $store.getters.user.id && operations.length === 0">
          <el-button type="danger" @click="handleDeleteRecord()">删除</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-main>
      <el-scrollbar ref="recordInfoScrollbar" class="default-scrollbar content-bg"
                    style="min-width: 960px;"
                    wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
        <div class="record-main-warpper">
          <div class="record-main-left">
            <time-line :style="{position: 'absolute', left: left, top: (recordTags.length === 0 ? '0' : '40px'), marginTop: '20px', height: '90%'}"
                       v-if="pat"
                       :patient="pat"
                       :record="record"
                       :hasOperation="operations && operations.length > 0"
                       @toRecord="toRecord">
            </time-line>
            <div class="record-main-left__warpper" style="width: 160px; height: 800px;"></div>
          </div>
          <div ref="recordContent" class="record-main-content">
            <div style="margin-bottom: 10px" v-if="recordTags.length > 0">
              <el-tag v-for="(recordTag, index) of recordTags"
                      :key="index"
                      closable
                      :disable-transitions="false"
                      @close="handleClose(recordTag)"
                      type="warning"
                      effect="plain"
                      style="margin-right: 10px;">{{recordTag}}</el-tag>
            </div>
            <div v-if="record" class="record-content">
              <div style="text-align: center; padding-bottom: 25px; line-height: 30px;">
                <div class="title">
<!--                  {{hospital ? hospital.name : record.hname}} - {{record.orgName}} - {{record.hospitalized === 1 ? '住院' : '门诊'}}-->
                  {{hospital ? hospital.name : record.hname}}
                </div>
                <div class="title" style="padding-top: 10px;">
                  {{record.hospitalized === 1 ? '住院' : '门诊'}}
                </div>
              </div>
              <div class="info-content clear" v-if="patient" ref="record_show_patient">
                <div class="info-content-title clear">
                    <span>患者信息</span>
                  <span class="title-btns">
                    <!--<el-button v-if="!this.attention" type="text" @click="handleAttention('add')">关注患者</el-button>
                    <el-button v-else type="text" @click="handleAttention('delete')">取消关注</el-button>-->
                    <el-button type="text" @click="handleEditPatient">修改</el-button>
                  </span>
                </div>
                <div class="info-content-body">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <span>姓名：{{patient.name}}</span>
                        </el-col>
                        <el-col :span="8">
                            <span>性别：{{patient.sex === 2 ? '女' : '男'}}</span>
                        </el-col>
                        <el-col :span="8">
                            <span>年龄：{{patient.age ? patient.age + '岁' : '未知'}}</span>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <span>电话：{{patient.mobile || '未填写电话'}}</span>
                        </el-col>
                        <el-col :span="8">
                            <span>身份证：{{patient.identity || '未填写身份证号'}}</span>
                        </el-col>
                        <el-col :span="8">
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <span>地址：{{patient.province || '未填写地址'}}{{patient.city}}{{patient.county}}{{patient.towns}}{{patient.village}}</span>
                        </el-col>
                        <el-col :span="8">
                            <span>详细地址：{{patient.house || '未填写门牌号'}}</span>
                        </el-col>
                        <el-col :span="8">
                        </el-col>
                    </el-row>
                </div>
              </div>
              <div class="info-content clear" v-if="record" ref="record_show_record">
                <div class="info-content-title clear">
                  <span>病历信息</span>
                  <span class="title-btns"><el-button type="text" @click="handleEditRecord">修改</el-button></span>
                </div>
                <div class="info-content-body">
                  <el-row :gutter="20">
                      <el-col :span="8">
                          <span>病历号：{{record.historySn}}</span>
                      </el-col>
                      <el-col :span="8">
                          <span v-if="record.hospitalized">床位号：{{record.bedid || '无'}}</span>
                      </el-col>
                      <el-col :span="8">
                      </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <span>主治医生：{{record.attendingName || '无'}}</span>
                    </el-col>
                    <el-col :span="8">
                      <span>科室：{{record.orgName}}({{record.hname}})</span>
                    </el-col>
                    <el-col :span="8">
                      <span>诊断：{{record.diagnoseNames || '无'}}</span>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <span>入院日期：{{ record.admissionDate | dateFilter }}</span>
                    </el-col>
                    <el-col :span="8" v-if="record.state === 7 && record.leaveTime">
                      <span>出院日期：{{ record.leaveTime | dateFilter }}</span>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <span>病情描述：{{record.stateOfAnIllness || '无'}}</span>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div class="info-content clear" v-if="diagnoses.length > 0" ref="record_show_diagnose">
                <div class="info-content-title clear">
                  <span>智能分级</span>
                </div>
                <div class="info-content-body">
                  <el-row :gutter="20" v-for="diagnose in diagnoses" :key="diagnose.id" v-if="diagnose.level !== 0">
                    <el-col :span="8">
                      <span>识别结果：关节炎  KL{{diagnose.level - 1 }}</span>
                    </el-col>
                    <el-col :span="8">
                      <span>检查时间：{{diagnose.time | dateFilter}}</span>
                    </el-col>
                    <el-col :span="8">
                      <a :href="diagnose.levelRefer" target="_blank" style="color: #179aff;" v-if="diagnose.levelRefer">查看图片 ></a>
                      <span v-else style="color: #cccccc">查看图片 </span>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div ref="record_show_operation" v-if="operations && operations.length > 0">
                <div class="info-content clear" v-for="operation in operations" :key="operation.id">
                  <div class="info-content-title">
                    <span>手术信息({{operation.currentState | operationStatus}})</span>
                    <span class="title-btns">
                      <el-button type="text" @click="handleApproveOperation(operation)" v-if="operation.currentState === 2 && hasPermission('per_opration_001002')">审批</el-button>
                      <el-button type="text" @click="handleFinishOperation(operation)" v-if="operation.currentState === 4 && $store.getters.user.id === operation.applyDoc">完成</el-button>
                      <el-button type="text" @click="handleEditOperation(operation)" v-if="$store.getters.user.id === operation.applyDoc && operation.currentState < 5">修改</el-button>
                      <el-button type="text" @click="handleEditOperation(operation)" v-if="operation.currentState > 5">申请</el-button>
                      <el-button style="color: #FF4949;" type="text" @click="handleDeleteOperation(operation)" v-if="(operation.currentState < 3 || operation.currentState > 5 || (hasPermission('per_opration_001002') && operation.currentState === 3)) && $store.getters.user.id === operation.applyDoc">删除</el-button>
                    </span>
                  </div>
                  <div class="info-content-body">
                    <aims-operation-base-info :operation="operation"></aims-operation-base-info>
                  </div>
                </div>
              </div>
              <div class="info-content clear" ref="record_show_images">
                <div class="info-content-title">图片信息</div>
                <record-record-image-list :record="record" ></record-record-image-list>
              </div>
              <div v-if="courses && courses.length > 0" ref="record_show_course">
                <div class="info-content clear" v-for="course in courses" :key="course.id">
                  <div class="info-content-title">
                    <span>{{course.tag}}</span>
                    <el-button type="text" style="float: right; color: #F56C6C;" @click="handleDeleteCourse(course)" v-if="$store.getters.user && course.creator === $store.getters.user.id">删除</el-button>
                    <el-button type="text" style="float: right; margin-right: 10px;" @click="handleEditCourse(course)" v-if="$store.getters.user && course.creator === $store.getters.user.id">编辑</el-button>
                  </div>
                  <div class="info-content-body">
                    <div class="course-author">
                      <strong><a href="javascript:void(0)">{{course.creatorName}}</a></strong>
                      <span class="course-author-date"> . {{course.time | dateFilter}}</span>
                    </div>
                    <div class="course-content clear">
                      {{course.remark}}
                    </div>
                    <!-- <record-image-list ref="images_course" :source-id="course.id" source="course" :mark="record.hname" :disabled="$store.getters.user && course.creator !== $store.getters.user.id"></record-image-list> -->
                    <record-image-list :ref="'images_course_' + course.id" :source-id="course.id" source="course" :mark="record.hname" :disabled="true"></record-image-list>
                  </div>
                </div>
              </div>
              <div class="info-content clear" v-if="hasConsultation" ref="record_show_consultation">
                <div class="info-content-title">会诊记录</div>
                <div class="info-content-body">
                  <record-consultation-list-comments ref="consultationListComments" :rid="record.id"></record-consultation-list-comments>
                </div>
              </div>
              <div class="info-content clear" v-if="record.hasFollowup" ref="record_show_followup">
                <div class="info-content-title">
                  <span>随访计划</span>
                  <span class="title-btns"><el-button type="text" @click="handleEditFollowup">修改</el-button></span>
                </div>
                <div class="info-content-body">
                  <followup-list-comments ref="followupListComments" :rid="record.id"></followup-list-comments>
                </div>
              </div>
              <div class="info-content clear" v-if="hasComments" ref="record_show_comment">
                <div class="info-content-title">
                  <span>批注</span>
                  <span class="title-btns"><el-button type="text" @click="startAddComment()">添加</el-button></span>
                </div>
                <div class="info-content-body">
                  <record-comments-list ref="recordCommentsList" :rid="record.id" @deleteComment="handleDeleteComment"></record-comments-list>
                </div>
              </div>
              <div class="record-footer">
                {{record.createName}}创建于{{record.createTime | dateTimeFilter}}[最新更新时间{{record.updateTime | dateTimeFilter}}]
              </div>
            </div>
          </div>
          <div class="record-main-right">
            <!-- 导航 -->
            <div class="anchor-list hidden-md-and-down"
                 style="width: 160px; padding-left: 20px; margin-top: 5px;"
                 :style="{position: 'absolute', right: right, top: (recordTags.length === 0 ? '0' : '40px')}">
              <ul style="width: 160px; padding-left: 10px">
                <li class="anchor-item" v-for="catalog in catalogs" :key="catalog.id">
                  <a href="javascript:void(0);" @click="scrollTo(catalog.id)">{{catalog.name}}</a>
                </li>
                <li class="anchor-item">
                  <a href="javascript:void(0);" @click="scrollTo(null)">回到顶部</a>
                </li>
              </ul>
            </div>
            <div class="nav-right" style="width: 160px"></div>
          </div>
        </div>
      </el-scrollbar>
    </el-main>
    <el-footer height="50px" class="hidden-lg-and-up">
      <div class="anchor-horizontal-list anchor-list hidden-lg-and-up">
        <ul class="clear">
          <li class="anchor-item" v-for="catalog in catalogs" :key="catalog.id">
            <a href="javascript:void(0);" @click="scrollTo(catalog.id)">{{catalog.name}}</a>
          </li>
          <li class="anchor-item">
            <a href="javascript:void(0);" @click="scrollTo(null)">回到顶部</a>
          </li>
        </ul>
      </div>
    </el-footer>
    <!-- 显示二维码 -->
    <!--<el-dialog title="患者咨询二维码" width="470px" :visible.sync="visibleQrcode" @close="closeQrcode">
      <img width="430" height="430" :src="PatientContactQrcode.qrcode" v-if="!PatientContactQrcode.loadding && PatientContactQrcode.qrcode">
      <div class="qrcode-remark" v-if="PatientContactQrcode.loadding"><span>正在生成二维码，请稍候...</span></div>
      <div class="qrcode-remark" v-if="!PatientContactQrcode.loadding && PatientContactQrcode.err"><span class="err">{{PatientContactQrcode.err}}</span></div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="visibleQrcode = false">确定</el-button>
      </div>
    </el-dialog>-->
    <!-- 编辑患者 -->
    <el-dialog title="编辑患者信息" :visible.sync="visibleEditPatient" @close="handleCloseEditPatient" :close-on-click-modal="false">
      <patient-edit
        ref="patientEditRef"
        v-if="visibleEditPatient"
        v-model="editPatient"
        :show-buttons="false"
        @cancle="visibleEditPatient = false"
        @saveDone="editPatientSuccess"
      ></patient-edit>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visibleEditPatient = false">取 消</el-button>
        <el-button type="primary" @click="$refs['patientEditRef'].savePatient()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑病历 -->
    <record-edit :visible="visibleEditRecord" :record="editRecord" @close="handleCloseEditRecord" @success="editRecordSuccess"></record-edit>
    <!-- 编辑手术 -->
    <el-dialog title="编辑手术" :visible.sync="visibleEditOperation" @close="handleCloseEditOperation" top="0" width="1000px" :close-on-click-modal="false">
      <aims-operation-edit
        ref="operationEditRef"
        v-model="editOperation"
        :show-buttons="false"
        @cancle="visibleEditOperation = false"
        @saveDone="editOperationSuccess"
      ></aims-operation-edit>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visibleEditOperation = false">取 消</el-button>
        <el-button type="primary" @click="$refs['operationEditRef'].submit()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑随访计划 -->
    <el-dialog title="随访计划" :visible.sync="visibleEditFollowup" :close-on-click-modal="false">
      <followup-list-edit
        ref="followupEditRef"
        :rids="record.id + ''"
        :show-buttons="false"
        @cancle="visibleEditFollowup = false"
        @saveDone="handleSaveFollowupDone"
      ></followup-list-edit>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visibleEditFollowup = false">取 消</el-button>
        <!-- <el-button type="primary" @click="$refs['followupEditRef'].addFollowup()">添加一项</el-button> -->
        <el-button type="primary" @click="$refs['followupEditRef'].save()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑病程 -->
    <el-dialog title="编辑病程" :visible.sync="visibleEditCourse" @close="handleCancleEditCourse" :close-on-click-modal="false">
      <record-course-edit
        ref="courseEditRef"
        v-model="editCourse"
        :show-buttons="false"
        :mark="record.hname"
        @cancle="handleCancleEditCourse"
        @saveDone="handleSaveCourseDone"
      ></record-course-edit>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visibleEditCourse = false">取 消</el-button>
        <el-button type="primary" @click="$refs['courseEditRef'].save()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑会诊 -->
    <el-dialog :close-on-click-modal="false" title="编辑会诊" :visible.sync="visibleEditConsultation" @close="handleCancelEditConsultation">
      <record-consultation-edit
        ref="recordConsultationEditRef"
        v-model="editConsultation"
        :show-buttons="false"
        @cancle="visibleEditConsultation = false"
        @saveDone="handleSaveConsultationDone"
      ></record-consultation-edit>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visibleEditConsultation = false">取 消</el-button>
        <el-button type="primary" @click="$refs['recordConsultationEditRef'].save()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 转科 -->
    <el-dialog :close-on-click-modal="false" title="转科" :visible.sync="visibleEditTransfer">
      <record-transfer-edit
        ref="recordTransferEditRef"
        :rid="record.id"
        :forg="record.oid"
        :bedid="record.bedid"
        @saveDone="handleSaveTransferDone"
      ></record-transfer-edit>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visibleEditTransfer = false">取 消</el-button>
        <el-button type="primary" @click="$refs['recordTransferEditRef'].save()">确定</el-button>
      </div>
    </el-dialog>
    <!--患者病历-->
    <el-dialog :close-on-click-modal="false" :title="'患者' + patient.name + '的病历'" :visible.sync="visibleMoreRecord" append-to-body fullscreen>
      <record-patient-record-selection :patient="pat" @selected="handleSelectedPatientRecord"></record-patient-record-selection>
    </el-dialog>
    <el-dialog title="标签" width="400px" :visible.sync="visibleEditTag" @close="saveRecordTags()">
      <record-tag :oid="record.oid" :record-tags="recordTags" @tagChange="changeRecordTag" append-to-body></record-tag>
    </el-dialog>
  </el-container>
</template>

<style scoped>
  .record-main-warpper {
    display: flex;
    justify-content: space-around
  }
  .record-main-content {
    flex: 1;
    max-width: 1050px;
    min-width: 800px;
    padding-top: 20px;
  }
  .record-main-left {
    flex: 0 0 160px;
  }
  .record-main-right {
    flex: 0 0 160px;
  }
  @media (max-width: 1200px) {
    .record-main-right {
      display: none;
    }
    .record-main-left {
      float: left;
    }
    .record-main-content {
      max-width: 1050px;
      min-width: 800px;
      padding-top: 20px;
      float: left;
    }
  }
  .content-bg {
    background: #F2F6FC;
  }

  .patient-info-box {
    padding: 20px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    background: #FFF;
    margin: 0 auto;
  }

  .patient-info-box .patient-info {
    /*width: 900px;*/
    float: left;
  }

  .patient-info-box .patient-item {
    float: left;
    font-size: 14px;
    color: #8e8e93;
    line-height: 24px;
    margin-right: 20px;
  }

  .patient-info-box .patient-item.name {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
  }

  .patient-info-box .patient-tools {
    width: 110px;
    float: right;
    font-size: 14px;
    line-height: 24px;
  }

  .patient-info-box .patient-tools i {
    margin: 0 20px;
    cursor: pointer;
  }

  .record-content {
    padding: 20px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    background: #FFF;
    margin: 0 auto;
  }
  .record-title {
    text-align: center;
    color: #8e8e93;
    margin-bottom: 20px;
  }
  .record-title .title,
  .record-title .sub-title {
    font-size: 30px;
  }
  .item-title {
    font-size: 14px;
    font-weight: bold;
  }
  .info-content {
    color: #8e8e93;
    position: relative;
  }
  .info-content a {
    color: #009a61;
    text-decoration: none;
    background: transparent;
  }
  .info-content a:hover,
  .info-content a:active,
  .info-content a:focus {
    outline: 0;
  }
  .info-content .info-content-title .title-btns {
    float: right;
  }
  .info-content .info-content-title {
    color: #303133;
    height: 36px;
    line-height: 36px;
    border-top: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    font-weight: 500;
    transition: border-bottom-color .3s;
    -webkit-transition: border-bottom-color .3s;
    font-size: 14px;
  }
  .info-content .info-content-body {
    color: #8e8e93;
    padding-top: 20px;
    padding-bottom: 25px;
    font-size: 14px;
    line-height: 1.769230769230769;
  }
  .record-footer {
    color: #8e8e93;
    line-height: 45px;
    font-size: 14px;
    text-align: right;
    border-top: 1px solid #ebeef5;
    transition: border-bottom-color .3s;
    -webkit-transition: border-bottom-color .3s;
  }
  .course-author {
    margin-bottom: 10px;
    color: #999;
    font-size: 13px;
  }
  .course-author strong {
    font-weight: bold;
  }
  .course-content {
    line-height: 1.6;
    word-wrap: break-word;
    margin-bottom: 10px !important;
  }
  .anchor-list {
    line-height: 48px;
  }
  .anchor-list.anchor-horizontal-list {
    position: relative;
    top: auto;
    right: auto;
  }
  .anchor-list ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .anchor-list.anchor-horizontal-list ul {
    text-align: right;
  }
  .anchor-list li.anchor-item {
    margin: 0;
    padding: 0;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .anchor-horizontal-list li.anchor-item {
    float: left;
    margin: 0 10px;
  }
  .anchor-list a {
    color: #009a61;
    text-decoration: none;
    background: transparent;
  }
  .qrcode-remark {
    width: 430px;
    height: 430px;
    display: table;
    text-align: center;
  }
  .qrcode-remark span {
    font-size: 24px;
    width: 100%;
    height: 100%;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }
  .qrcode-remark span.err {
    color: #F56C6C;
  }
  .title {
    font-size: 24px;
    color: #8e8e93;
  }
</style>
